import React, { useState, useEffect, Fragment, forwardRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import './bookingtime.scss';
import Icon from '@mdi/react';

import { mdiPencil, mdiReload } from '@mdi/js';

import { mdiArrowLeft, mdiClose, mdiCalendar, mdiClockTimeTwoOutline, mdiLightbulbFluorescentTubeOutline } from '@mdi/js';
import { Link, Navigate, NavLink } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useForm, Controller, set } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axios from "axios";
import Modal from 'react-modal';
import agent from '../../agent';
import dateIcon from './DateSlot.svg'
import dropdownicon from "../ProfileMenu/images/dropdownicon.png"
import checkSlotTimeIcon from "./TimeSlot.svg"

import clockIcon from "../TuneUp/Clock.svg"
import dollarIcon from "../TuneUp/CurrencyBg.svg"
import calendarIcon from "../TuneUp/Calendar.svg"
import orderClockIcon from "../TuneUp/Time.svg"
import durationIcon from "../TuneUp/duration.svg"
import CustomFunction from '../../components/customFuction';
import closeIcon from "../TuneUp/CloseIcon.svg"

// import CHECK_AVAILABILITY_SLOT from '../../constants/actionTypes';

// import { ORDER_LOAD, ORDER_UNLOAD, PROFILE_INFORMATION_LOAD, PROFILE_INFORMATION_UPDATE_ZIPCODE, VEHICLE_TYPES_LOAD,
//   VEHICLE_MODELS_LOAD,
//   VEHICLE_MAKES_LOAD, CHECK_AVAILABILITY_SLOT, ORDER_LOAD_SUCCESS  } from '../../constants/actionTypes';
import DatePicker from "react-datepicker";
import { addDays } from 'date-fns';
import { Helmet } from "react-helmet";
import "react-datepicker/dist/react-datepicker.css";
import Select, { components } from 'react-select'
import { configureStore } from '@reduxjs/toolkit';
import { HANDLE_401_ERROR } from '../../constants/actionTypes';
import Footer from '../../components/Footer/Footer';

const mapStateToProps = state => ({ ...state });

const BookingTime = (props) => {

 // console.log("props on booking time", props);
  //console.log("mapstatetoprops", mapStateToProps);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(true);
  const [isButtonLoading, setButtonLoading] = useState(false);
  const [orderTimeSlotButtonLoading, setOrderTimeSlotButtonLoading] = useState(false);
  const [bookingInfoError, setBookingInfoError] = useState("");
  const [bookingInfoSuccess, setBookingInfoSuccess] = useState("");
  const [editState, setEditState] = useState(false);
  const [vehicleData, setVehicleData] = useState({});
  const [cardAddPopup, setCardAddPopup] = React.useState(true);
  // Zip code
  // const [zipCodeServiceCheck, setZipCodeServiceCheck] = useState("");
  // const [zipCodeServiceData, setZipCodeServiceData] = useState("");

  // const [zipCode, setZipCode] = useState('');
  const [cityName, setCityName] = useState('');
  // ProfileInfo
  const [userData, setUserData] = useState();
  // const [vehicleTypes, setVehicleTypes] = useState('');
  // const [vehicleMakes, setVehicleMakes] = useState('');
  // const [vehicleModels, setVehicleModels] = useState('');

  const [bikeTypeList, setBikeTypeList] = useState([]);
  const [bikeTypeOptions, setBikeTypeOptions] = useState([]);
  // console.log("bike-list",data.results?.vehicle_info?.type.display_name)
  const [bikeTypes, setBikeTypes] = useState('');
  const [bikeTypeId, setBikeTypeId] = useState('');
  const [bikeMakeList, setBikeMakeList] = useState([]);
  const [bikeMakes, setBikeMakes] = useState('');
  // const [bikeMakeId, setBikeMakeId] = useState('');
  const [bikeModelList, setBikeModelList] = useState([]);
  const [bikeModels, setBikeModels] = useState('');
  const [bikesGearId, setBikesGearId] = useState('');
  const [bikesMakeId, setBikesMakeId] = useState('');
  const [bikesTypeId, setBikesTypeId] = useState('');
  const [typeData, setTypeData] = useState('')
 // console.log("typeData", typeData);
  const [bikeTypeTax, setBikeTypeTax] = useState('');
  // Booking Slot time data and popup
  const [bookingOrderTimeSlotData, setBookingOrderTimeSlotData] = useState([]);
  const [bookingOrderSuccess, setBookingOrderSuccess] = useState('');
  const [bookingOrderError, setBookingOrderError] = useState('');
  const [bookingOrderTimeSlotModalIsOpen, setBookingOrderTimeSlotModalIsOpen] = React.useState(false);
  const [bookingValues, setBookingValues] = useState('');
  const [editable, setEditable] = useState(false);


  // oreder popup
  const [bookingModalIsOpen, setBookingModalISOpen] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState('');
  const [zipcodePopUp, setZipcodePopUp] = useState(false);
  const [zipError, setZipError] = useState(false);

  // UseForm React form validation
  const validationSchema = Yup.object({
    address: Yup.string().required('Address is required')
      .matches(/^\S.*\S$/, 'Address should not start or end with whitespaces.')
      .min(6, 'Address should be at least six characters long')
      .max(256, 'Address should not exceed 256 characters.'),
    city: Yup.string(),
    zip_code: Yup.string()
      .matches(/^[\S]*$/, 'Zip code cannot contain whitespace.')
      .matches(/^\d{5}(?:[-]\d{4})?$/, 'Invalid zip code format.'),
    biketype: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable()
      .required('This field is required.'),
    bikemake: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable()
      .required('This field is required.'),
    bikemodel: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable()
      .required('This field is required.'),
    order_date: Yup.string().nullable().required("Order Date is required."),
    promo_code: Yup.string().nullable(),

  });

  const modalValidationSchema = Yup.object({
    order_slot_time: Yup.object()
      // .shape({
      //   value: Yup.string(),
      //   label: Yup.string(),
      //   disabled: Yup.string(),
      // })
      .nullable()
      .required('Time slot is required.')
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const modalFormOptions = {
    resolver: yupResolver(modalValidationSchema)
  };

  const { register, handleSubmit, setValue, control, reset, formState: { errors } } = useForm(formOptions);

  const { handleSubmit: modalhandleSubmit, control: modalControl, formState: { errors: modalErrors } } = useForm(modalFormOptions);


  const convertArrayToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
      return {
        value: item.value, label: item.label
      };
    }, initialValue);
  };

  const CaretDownIcon = () => {
    return <img className="fas fa-caret-down" src={dropdownicon} alt='drop down icon' />;
  };

  const CheckSlotIcon = () => {
    return <img className="fas fa-caret-down" src={checkSlotTimeIcon} alt='check slot time icon' />;
  };


  const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <input
      style={{ borderColor: "none" }}
      value={value}
      className="example-custom-input"
      onClick={onClick}
      onChange={onChange}
      ref={ref}
    ></input>
  ));


  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator style={{ width: "0px !important" }} {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };

  const timeDropdownIndicator = props => {
    return (
      <components.DropdownIndicator style={{ width: "0px !important" }} {...props}>
        <CheckSlotIcon />
      </components.DropdownIndicator>
    );
  };

  const cardAddPopupClose = () => {
    setCardAddPopup(false);
    refreshPage();
  }

  function refreshPage() {
    window.location.reload(false);
  }



  // const getProfileInfo = async () => {
  //   setLoading(true)
  //   const accessToken = JSON.parse(localStorage.getItem("access_token"));
  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "application/json",
  //         'x-access-token': `${accessToken}`
  //       },
  //     };
  //     const response = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + '/user', config);
  //     setUserData([response?.data]);
  //     console.log(" user data", response);
  //     //console.log(" user data", response?.data?.results?.address?.address);
  //     // const [types, makes, models] = await Promise.all([
  //     //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/types', config),
  //     //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/make', config),
  //     //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/model', config)
  //     // ]);
  //     // setVehicleTypes(types.data)
  //     // setVehicleMakes(makes.data)
  //     // setVehicleModels(models.data)
  //     setLoading(false)
  //     //console.log(response)

  //   } catch (error) {
  //     setLoading(false)
  //     console.log(error)
  //   }
  // };

  //console.log("userdata", userData);
  //console.log(userData?.[0]?.results?.address?.address);


  const onChangeZipCode = async (value) => {
    let newZipCode = value.target.value;
    if (newZipCode.length !== 5 || isNaN(newZipCode)) {
      setValue('city', '');
      setValue('state', '');
      return;
    } else {
      // setLoading(true)

      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
            'x-access-token': `${accessToken}`,
            'x-request-time': new Date().toString(),
            'x-request-timezone': timeZone
          },
        };
        const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `/zip-county/zipcode/${newZipCode}`, config);

        // setLoading(false);
        setValue('city', data?.results[0].city);
        setValue('state', data?.results[0].state);

        // let cityName = setCityName(data.results[0].city);
        // console.log("CITY", cityName)

      } catch (error) {
        setZipcodePopUp(true);
        HANDLE_401_ERROR(error.response?.status);
        // setCityName('');
       // console.log(error);
        // if(error.response.data.service_available == false) {
        //   setZipCodeServiceCheck('Please enter available zip code');
        // }
      }
    }
  }


  useEffect(() => {
    if (Object.keys(props.services).length === 0) {
      return navigate("/home");
    }

    setBookingOrderTimeSlotModalIsOpen(false)
    setBookingInfoError('')
    setBookingOrderTimeSlotData('')
    setBookingModalISOpen(false);
    bikeInfo();
  }, []);

  useEffect(() => {
    if (bikeTypes) {
      bikeMakeInfo(bikeTypes);
    }
    if (bikeMakes) {
      bikeModelInfo(bikeMakes);
    }
  }, [bikeMakes, bikeTypes]);


  const getProfileInfo = async () => {
    setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      //console.log("Configuration", config)
      const response = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'user', config);
      //console.log("DATA",data)
      setUserData(response?.data);
      setTypeData(response?.data?.results?.vehicle_type?.tax_percentage);
      // console.log("BIKE TYPE PERCENTAGE", response?.data?.results?.vehicle_type?.tax_percentage);
      // console.log("user_data", response?.data)
      // setValue('first_name', data?.results?.first_name);
      // setValue('last_name', data?.results?.last_name);
      // setValue('email', data?.results?.email);
      // setValue('address', userData?.[0].results?.address?.address);
      setValue('zip_code', response?.data?.results.address?.zipcode);
      // setValue('mobile', data?.results?.mobile);
      setValue('city', response?.data?.results.address?.city);
      setValue('state', response?.data?.results.address?.state);

      // document.getElementById('email').attributes('disabled', true);
      if (response?.data?.results) {
        // console.log("booking_info", response?.data?.results);
        let { vehicle_info } = response?.data?.results;
        let _bikeTypeList = [response?.data?.results?.vehicle_type];
        let _bikeMakeList = [response?.data?.results?.vehicle_make];
        let _bikeModelList = [response?.data?.results?.vehicle_gear];

        setBikeTypeList(_bikeTypeList);

        let selectedBikeType = _bikeTypeList.map((item, index) => ({
          value: item?._id,
          label: item?.display_name
        }))
        // console.log("_bikeTypeList", _bikeTypeList)
        // console.log("selectedBikeType", selectedBikeType)
        setBikeTypes(selectedBikeType[0])
        setValue('biketype', selectedBikeType[0])

        /////////////////////////////////

        setBikeMakeList(_bikeMakeList);

        let selectedBikeMake = _bikeMakeList.map((item, index) => ({
          value: item?._id,
          label: item?.display_name
        }))
        // console.log("_bikeMakeList", _bikeMakeList)
        setBikeMakes(selectedBikeMake[0])
        setValue('bikemake', selectedBikeMake[0])



        setBikeModelList(_bikeModelList);

        let selectedBikeModel = _bikeModelList.map((item, index) => ({
          value: item?._id,
          label: item?.display_name
        }))
        // console.log("_bikeModelList", _bikeModelList)
        // console.log("selectedBikeModel", selectedBikeModel)
        setBikeModels(selectedBikeModel[0])
        setValue('bikemodel', selectedBikeModel[0])
        setBikesGearId(selectedBikeModel[0].value)
      }

      setLoading(false);
      // const [types, makes, models] = await Promise.all([
      //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'vehicle/type', config),
      //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'vehicle/make', config),
      //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'vehicle/model', config)
      // ]);
      // setVehicleTypes(types.data)
      // setVehicleMakes(makes.data)
      // setVehicleModels(models.data)

    } catch (error) {
      setLoading(false)
      HANDLE_401_ERROR(error.response?.status);
      //console.log(error)
    }
  };

  useEffect(() => {
    getProfileInfo();
  }, []);


  const bikeInfo = async () => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/type', config);
      // console.log("data of bikes", data);
      setBikeTypeOptions(data.results);
      // console.log("bikelist", bikeTypeList)
    } catch (error) {
     // console.log(error);
    }
  };

  const bikeMakeInfo = async (bikeTypes) => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      // const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/make/v-type/' + bikeTypes.value);
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/make', config);
      setBikeMakeList(data.results)
      // console.log("vehicleMake", bikeMakeList)
    } catch (error) {

    }
  }

  const bikeModelInfo = async (bikeMakes) => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      // const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/model/v-make/' + bikeMakes.value);
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/gear', config);
      setBikeModelList(data.results)
      // console.log("vehicleModel", bikeModelList)
    } catch (error) {

    }
  }

  const handleBikeValueChange = (selectedOption) => {
    // console.log("handleBikeValueChange", selectedOption.label)
    setBikeTypes(selectedOption);

  }



  // const handleBikeMakeChange = (selectedOption) => {
  //   console.log("handleBikeMakeChange", selectedOption.value)
  //   setBikeMakes(selectedOption);



  // }

  // const handleBikeModelChange = (selectedOption) => {
  //   console.log("handleBikeModelChange", selectedOption)
  //   setBikeModels(selectedOption);
  //   setBikesModelId(selectedOption.value);
  // }
  // const bikeInfo = async () => {
  //   const accessToken = JSON.parse(localStorage.getItem("access_token"));
  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "application/json",
  //         'x-access-token': `${accessToken}`
  //       },
  //     };
  //     const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/type', config);
  //     setBikeTypeList(data.results)
  //     //console.log("bike type list", bikeTypeList)
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const bikeMakeInfo = async (bikeType) => {
  //   const accessToken = JSON.parse(localStorage.getItem("access_token"));
  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "application/json",
  //         'x-access-token': `${accessToken}`
  //       },
  //     };
  //     const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/make/v-type/' + bikeType.value, config);
  //     setBikeMakeList(data.results)
  //     //console.log("vehicle make List", bikeMakeList)
  //   } catch (error) {

  //   }
  // }

  // const bikeModelInfo = async (bikeMake) => {
  //   const accessToken = JSON.parse(localStorage.getItem("access_token"));
  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "application/json",
  //         'x-access-token': `${accessToken}`
  //       },
  //     };
  //     const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/model/v-make/' + bikeMake.value, config);
  //     setBikeModelList(data.results)
  //     //console.log("vehicle Model List", bikeModelList)
  //   } catch (error) {

  //   }
  // }

  // const handleBikeValueChange = (selectedOption) => {
  //   setBikeType(selectedOption);
  //   // setBikeMakeList([]);
  //   // setBikeModelList([]);
  //   // setBikeMake("");
  //   // setBikeModel("");
  // }

  // const handleBikeMakeChange = (selectedOption) => {
  //   setBikeMake(selectedOption);
  //   // setBikeModelList([]);
  //   // setBikeModel("");

  // }

  // const handleBikeModelChange = (selectedOption) => {
  //   console.log("bikemodel selection", selectedOption);
  //   setBikeModel(selectedOption);

  // }


  // console.log("user data", userData);
  // console.log("bike type", bikeTypes);
  // console.log("bike make", bikeMakes);
  // console.log("bike model", bikeModels);
  let state = userData?.results?.address?.state ? userData?.results?.address?.state : '';
  let address = userData?.results?.address?.address ? userData?.results?.address?.address : '';
  //console.log("address", address);
  // let city = userData?.results?.address?.city ? userData?.results?.address?.city : '';
  //console.log(city, "city");
  // let zipcode = userData?.results?.address?.zipcode ? userData?.results?.address?.zipcode : '';
  // console.log("zipcode", zipcode);
  // let country = userData?.results?.[0]?.address?.state ? userData?.[0]?.results?.address?.state : '';
  //console.log("country", country);


  let serDetails = '';
  serDetails = props.services.orderService;
  //console.log("serDetails", serDetails);
  let duration = serDetails?.duration;
  //console.log(" Props of services", props.services);
  let replaceparts = '';
  let planid = '';
  let service = '';
  let plancost = '';


  if (serDetails) {
    if (serDetails.replace_parts) {
      replaceparts = serDetails.replace_parts;
    }
    if (serDetails.planId) {
      planid = serDetails.planId;
    }
    if (serDetails.service) {
      service = serDetails.service;
    }
  }

  // let modelOptions = [];
  // let typeOptions = [];
  // let makeOptions = [];
  // let makeOptionsDefaultVal = null;
  // let modelOptionsDefaultVal = null;
  // let typeOptionsDefaultVal = null;

  // if (vehicleMakes) {
  //   let data = vehicleMakes;
  //   makeOptions = data.map(({ name, display_name }) => ({ value: name, label: display_name }));
  //   console.log("bikemake", bikemake);
  //   makeOptionsDefaultVal = convertArrayToObject(makeOptions.filter(option => option.value === bikemake));
  // }
  // if (vehicleTypes) {
  //   let data = vehicleTypes;
  //   typeOptions = data.map(({ name, display_name }) => ({ value: name, label: display_name }));
  //   console.log("biketype", biketype);
  //   typeOptionsDefaultVal = convertArrayToObject(typeOptions.filter(option => option.value === biketype));
  // }
  // if (vehicleModels) {
  //   let data = vehicleModels;
  //   modelOptions = data.map(({ name, display_name }) => ({ value: name, label: display_name }));
  //   console.log("bikemodel", bikemodel);
  //   modelOptionsDefaultVal = convertArrayToObject(modelOptions.filter(option => option.value === bikemodel));
  // }

  // Get Slot Available Time Form
  const onSubmit = async (data) => {
    // alert("HI")
    //console.log("data on submit", data);

    setBookingValues(data);
    setButtonLoading(true)
    setBookingInfoError('');
    // setLoading(true);

    // setBookingOrderTimeSlotData('')
    // reset(bookingOrderTimeSlotData);

    // let orderDate = new Date(data.order_date).toLocaleString();
    const dateString = data.order_date;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const formattedDate = `${year}/${month}/${day}`;
    // console.log(formattedDate);
    //console.log();
    // let orderDate = '';
    // if (data.order_date) {
    //   orderDate = `${orderDateIn.getFullYear()}/${orderDateIn.getMonth()}/${orderDateIn.getDate()}`
    //   // console.log(orderDate);
    //   // orderDateIn = Date.parse(orderDateIn) / 1000
    // }
    let country_code = 'US';
    let plan_id = userData?.results?._id;
    //console.log(data.zip_code);
    let zipcode1 = data.zip_code;
    
    //console.log("zipcode on submit from", zipcode1, userData?.[0]?.results?.address?.zipCode, zipcode);

    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },

      };
      const response = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `check-slot?zipcode=${zipcode1}&date=${formattedDate}&duration=${duration}`, config);
      // console.log("time slot response", response?.data?.results?.availabe_slots);
      setBookingOrderTimeSlotData(response?.data?.results?.availabe_slots);
      // console.log("booking slot response", bookingOrderTimeSlotData);
      setBookingOrderTimeSlotModalIsOpen(true);
      setButtonLoading(false);
    } catch (error) {
      setBookingInfoError(error.response.data.message)
      HANDLE_401_ERROR(error.response?.status);
      setButtonLoading(false)
     // console.log(error)
    }
    //return dispatch({ type: CHECK_AVAILABILITY_SLOT, payload: agent.OrderBooking.slot_availability(country_code, zipcode, plan_id, orderDateIn) })
  }

  // let availabilitySlotTime = [];
  // if(bookingOrderTimeSlotData.length > 0) {
  //   console.log(bookingOrderTimeSlotData)
  //   availabilitySlotTime = bookingOrderTimeSlotData;
  // }
  // console.log("IMAGE", props?.services?.orderService);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '30px 15px',
      width: '90%'
    },
  };


  const slotTime = orderSuccess?.results?.slot_time; // Assuming slotTime is in minutes
  const hours = Math.floor(slotTime / 60);
  const minutes = slotTime % 60;

  let period = "AM";
  if (hours >= 12) {
    period = "PM";
  }
  let adjustedHours = hours % 12;
  if (adjustedHours === 0) {
    adjustedHours = 12;
  }

  function formatTime(hours, minutes, period) {
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${period}`;
  }

  const orderTime = formatTime(adjustedHours, minutes, period);

  function dateFormat(dateString) {
    const date = new Date(dateString);
    const options = { month: 'short', day: '2-digit', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options).replace(/, /g, ', ');
    return formattedDate;
  }

  // function dateFormat(dateString) {
  //   const date = new Date(dateString);
  //   const month = date.toLocaleDateString('en-US', { month: 'short' });
  //   const day = date.getDate();
  //   const year = date.getFullYear();
  //   const formattedDate = `${month}, ${day}, ${year}`;
  //   return formattedDate;
  // }

  const customClockStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? '#ff7f50' : provided.border,
      boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
      '&:hover': {
        border: '1px solid #ff7f50',
      },
    }),
    // indicatorSeparator: (provided) => ({
    //   ...provided,
    //   background: `url(${clockIcon})`,
    //   backgroundSize: 'contain',
    //   backgroundRepeat: 'no-repeat',
    //   backgroundPosition: 'center',
    //   width: '20px',
    //   height: '20px',
    // }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#ff7f50' : 'white',
      color: state.isSelected ? 'white' : 'black',
      fontSize: '1rem',
      '&:hover': {
        backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
        color: state.isSelected ? 'white' : 'black',
      },
    }),
  }

  function bookingOrderTimeSlotModalIsCloseModal() {
    setBookingOrderError('');
    setBookingOrderTimeSlotModalIsOpen(false);
  }

  function closeModelZipcode() {
    setZipcodePopUp(false)
  }

  function bookingModalIsCloseModal() {
    setBookingModalISOpen(false);
    // navigate('/home');
    navigate(`/order-details/${orderSuccess?.results?._id}`);
  }

  // Order Complete Popup
  const onBookingSubmit = async (formdata) => {
    setOrderTimeSlotButtonLoading(true);
    // console.log("Form Data order date", formdata.order_date);
    let orderDate = new Date(bookingValues.order_date).toLocaleDateString("en-US");
   // console.log("Order data", orderDate);
    // let orderDate = '';
    // if (formdata.order_date) {
    //   orderDate = `${orderDateIn.getFullYear()}/${orderDateIn.getMonth()}/${orderDateIn.getDate()}`

    //   // orderDateIn = Date.parse(orderDateIn) / 1000
    // }

    let partsFileUpload = props.imageupload.file_upload ? props.imageupload.file_upload : [];
    let bikemakedt = formdata.bikemake ? formdata.bikemake.value : '';
    let bikemodeldt = formdata.bikemodel ? formdata.bikemodel.value : '';
    let biketypedt = formdata.biketype ? formdata.biketype.value : '';
    const orderSlotTime = formdata.order_slot_time ? formdata.order_slot_time.value : '';

    const restApi = axios.create({
      baseURL: process.env.REACT_APP_RIDEDOC_API_ROOT,
      responseType: 'json',
      withCredentials: false
    });

    // setBookingValues(val);


    let url = 'order';
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();

    try {

      const res = await restApi(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'x-access-token': `${accessToken}`,
          'Content-Type': 'application/json',
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone,
          'x-request-localtime': isoWithOffset(),
        },
        data:
        {
          customer: userData?.results?._id,
          promo_code: bookingValues.promo_code,
          address: {
            address: bookingValues.address,
            zipcode: bookingValues.zip_code,
            city: bookingValues.city,
            state: bookingValues.state,
            country: 'United States',
            latitude: props?.common?.currentUser?.results?.address?.latitude,
            longitude: props?.common?.currentUser?.results?.address?.longitude
          },
          service: props?.services?.orderService?.service_id,
          parts_replacement: serDetails?.replace_parts,
          plan: serDetails?.planId,
          plan_duration: serDetails?.duration,
          slot_date: orderDate,
          slot_time: orderSlotTime,
          vehicle_images: [props?.services?.orderService?.image],
          vehicle_gear: bikesGearId,
          vehicle_type: bikesTypeId,
          vehicle_make: bikesMakeId
        }
      });
      // console.log("res slot", res);
      setOrderSuccess(res?.data);
      setOrderTimeSlotButtonLoading(false);
      setBookingModalISOpen(true);
      setBookingOrderTimeSlotModalIsOpen(false);


    }
    catch (error) {
     // console.log(error);
     const message = error?.response?.data?.message || "Something went wrong";
      setBookingOrderError(message);
      setOrderTimeSlotButtonLoading(false);
      HANDLE_401_ERROR(error.response?.status);
      
    }
  }

  const handleResetOptions = (selectedOption, selectedValue) => {

  };

  const handleModelReset = (selectedOption, selectedValue) => {
    if (selectedOption.value !== selectedValue) {
      setValue('bikemodel', '');
    }
  };


  // const handleModelReset = () => {
  //   setValue('bikemodel', '');
  // }


  return isLoading ? (   //Checkif if is loading
    <div className="lds-ripple"><div></div><div></div></div>
  ) : (
    <Fragment>
      { !bookingOrderTimeSlotModalIsOpen && !bookingModalIsOpen ? (
      <div className='booking-info'>
        <div className='main'>
          <Helmet>
            <title>RideDoc | Booking Time</title>
            <meta name="description" content="Mobile bike mechanics at your door step" />
          </Helmet>
          <div className='header-wrp'>
            <header>
              <div className="header-backic">
                <button onClick={() => navigate(-1)} className="header-backic-icon">
                  <Icon path={mdiArrowLeft} size={'28px'} color="#222" />
                </button>
              </div>
              {/* <p className="header-mnutxt">{serDetails?.service}</p> */}
              <div className='service-header-text'>
                <p className="header-mnutxt service-title">Service Details</p>
              </div>
            </header>
          </div>

          <div className='main-wrapper booking-main'>

            <div className="profile-info-wrp booking-wrp" >
              <section className="booking-info-sec-wrp" style={{marginLeft: "1rem", marginRight: "1rem"}}>
                {bookingInfoError && <span className='error'>{bookingInfoError}</span>}
                {bookingInfoSuccess && <span className='success'>{bookingInfoSuccess}</span>}
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-hd-lbl bike-info-hd">
                    <h3>Bike Information</h3>
                    {/* <Icon path={mdiPencil} onClick={handleEdit} size={1} style={{ position: 'absolute', right: 0 }} /> */}

                  </div>
                  <div className="form-group-wrp">
                    <div className='row'>
                      <div className='col'>
                        <div className="form-group type-group">
                          {/* <label className="form-select" htmlFor="biketype">Bike Type</label> */}
                          <Controller
                            name="biketype"
                            // isDisabled={editState}
                            control={control}
                            // value={bikeTypes}
                            defaultValue={bikesTypeId}
                            render={({ field: { onChange, value } }) => (
                              <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  border: state.isFocused ? '#ff7f50' : provided.border,
                                  boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
                                  '&:hover': {
                                    border: '0.5px solid #ff7f50',
                                  },
                                }),

                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isSelected ? '#ff7f50' : 'white',
                                  color: state.isSelected ? 'white' : 'black',
                                  fontSize: '1rem', 
                                  '&:hover': {
                                    backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
                                    color: state.isSelected ? 'white' : 'black',
                                  },
                                }),
                              }}
                                // styles={customStylesSelect}
                                // isClearable
                                name="biketype"
                                placeholder="Bike Type"
                                isSearchable={false}
                                components={{ DropdownIndicator }}

                                className="react-dropdown dropdown-type react-custom"
                                classNamePrefix="dropdown"
                                // defaultValue={value}
                                value={value}
                                options={bikeTypeOptions.map((item, index) =>
                                ({

                                  value: item?._id,
                                  label: item?.display_name,
                                  item: item
                                }))}
                                // onChange={onChange}
                                onChange={(selectedOption) => {
                                  // handleResetOptions(selectedOption, value);
                                  onChange(selectedOption);
                                  setTypeData(selectedOption?.item?.tax_percentage);
                                }}
                                onInputChange={setBikesTypeId(value.value)}
                              // isOptionSelected={handleResetOptions}

                              />
                            )}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group bike-select">
                          {/* <label className="form-select" htmlFor="bikemake">Bike Make</label> */}
                          <Controller
                            name="bikemake"
                            //value={bikeMakes}
                            control={control}
                            defaultValue={bikesMakeId}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                name="bikemake"
                                placeholder="Bike Make"
                                components={{ DropdownIndicator }}
                                styles={{                                 
                                  control: (provided, state) => ({
                                    ...provided,
                                    border: state.isFocused ? '#ff7f50' : provided.border,
                                    boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
                                    '&:hover': {
                                      border: '0.5px solid #ff7f50',
                                    },
                                  }),

                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected ? '#ff7f50' : 'white',
                                    color: state.isSelected ? 'white' : 'black',
                                    fontSize: '1rem', 
                                    '&:hover': {
                                      backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
                                      color: state.isSelected ? 'white' : 'black',
                                    },
                                  }),
                                }}
                                // styles={customStylesSelect}
                                // defaultValue = {
                                //   makeOptions.filter(option => option.value === bikemake)
                                // }
                                // isClearable
                                // isDisabled={editState}
                                isSearchable={true}
                                className="react-dropdown react-custom"
                                classNamePrefix="dropdown"
                                // defaultValue={value}
                                value={value}
                                options={bikeMakeList.map((item, index) => ({
                                  value: item?._id,
                                  label: item?.display_name
                                }))}
                                // onChange={onChange}
                                onChange={(selectedOption) => {
                                  // handleModelReset(selectedOption, value);
                                  onChange(selectedOption);
                                }}
                                onInputChange={setBikesMakeId(value.value)}
                              // isOptionSelected={handleModelReset}


                              />
                            )}
                          />
                        </div>
                        {errors.bikemake &&
                          <div className="invalid-feedback">{errors.bikemake?.message || errors.bikemake?.label.message}</div>
                        }
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="form-group model-select">
                          {/* <label className="form-select" htmlFor="bikemodel">Bike Model</label> */}
                          <Controller
                            name="bikemodel"
                            // value={bikeModels}
                            control={control}
                            defaultValue={bikesGearId}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                name="bikemodel"
                                placeholder="Gear Type"
                                // label="Bike Model"
                                components={{ DropdownIndicator }}
                                styles={{                                 
                                  control: (provided, state) => ({
                                    ...provided,
                                    border: state.isFocused ? '#ff7f50' : provided.border,
                                    boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
                                    '&:hover': {
                                      border: '0.5px solid #ff7f50',
                                    },
                                  }),

                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected ? '#ff7f50' : 'white',
                                    color: state.isSelected ? 'white' : 'black',
                                    fontSize: '1rem', 
                                    '&:hover': {
                                      backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
                                      color: state.isSelected ? 'white' : 'black',
                                    },
                                  }),
                                }}
                                // styles={customStylesSelect}
                                // defaultValue = {
                                //   modelOptions.filter(option => option.value === bikemodel)
                                // }
                                // isClearable
                                // isDisabled={editState}
                                isSearchable={false}
                                className="react-dropdown dropdown-model react-custom"
                                classNamePrefix="dropdown"
                                // defaultValue={value}
                                value={value}
                                options={bikeModelList.map((item, index) => ({
                                  value: item?._id,
                                  label: item?.display_name
                                }))}
                                onChange={onChange}
                                onInputChange={
                                  // setBikeModels(value)
                                  setBikesGearId(value.value)

                                }
                              />
                            )}
                          />
                        </div>
                        {errors.bikemodel &&
                          <div className="invalid-feedback">{errors.bikemodel?.message || errors.bikemodel?.label.message}</div>
                        }
                      </div>
                      {/* <div className="col">
                        <div className="form-group">
                        <p style={{paddingLeft: 20, paddingTop: 10}}>Bike Type Tax : {typeData}%</p>
                        </div>
                      </div> */}
                    </div>
                    {errors.biketype &&
                      <div className="invalid-feedback">{errors.biketype?.message || errors.biketype?.label.message}</div>
                    }
                  </div>
                  <div className="form-hd-lbl service-hd">
                    <h3>Service Location</h3>
                  </div>
                  <div className="form-group-wrp">
                    <div className="form-group service-grp">
                      <textarea className="form-control form-control-textarea" name="address" defaultValue={address} {...register('address')} id="address" cols="30" rows="20"></textarea>
                      <label className="form-lbl" htmlFor="address">Address</label>
                    </div>
                    {errors.address &&
                      <div className="invalid-feedback">{errors.address?.message}</div>
                    }
                    <div className="location-row" style={{ display: "flex", justifyContent: "space-between" }}>
                      <div className="zipcode-field" style={{ width: "25%" }}>
                        <div className="form-group zipcode-grp">
                          <input
                            name='zip_code'
                            className="form-control form-zipcode"
                            type="text"
                            maxLength={5}
                            defaultValue=''
                            {...register('zip_code', {
                              onChange: (e) => {
                                onChangeZipCode(e);
                              },
                            })}
                          />
                          {/* <input className="form-control" type="text" name="country" id="country" {...register('country')} defaultValue={country} hidden /> */}
                          <label className="form-lbl lbl-zipcode" htmlFor="zip_code">Zip Code</label>
                        </div>
                        {/* {zipCodeServiceCheck &&
                        <div className="invalid-feedback">{zipCodeServiceCheck}</div>
                      } */}
                        {errors.zip_code &&
                          <div className="invalid-feedback">{errors.zip_code?.message}</div>
                        }

                      </div>
                      <div className="city-field" style={{ width: "45%" }}>
                        <div className="form-group zipcode-grp">
                          <input className="form-control form-city" type="text" name="city" id="city" {...register('city')} readOnly defaultValue=''></input>
                          <label className="form-lbl lbl-city" htmlFor="city">City</label>
                        </div>
                        {errors.city &&
                          <div className="invalid-feedback">{errors.city?.message}</div>
                        }
                      </div>
                      <div className="state-field" style={{ width: "25%" }}>
                        <div className="form-group zipcode-grp">
                          <input
                            className="form-control form-state"
                            type="text"
                            name="state"
                            id="state"
                            //value={zipcode}
                            {...register('state')}
                          />
                          <label className="form-lbl lbl-state" htmlFor="state">State</label>
                        </div>
                        {errors.state &&
                          <div className="invalid-feedback">{errors.state?.message}</div>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="form-group-wrp" style={{ position: 'relative' }}>
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <div className="form-hd-lbl date-hd">
                            <h3>Service Date</h3>
                          </div>
                          <div className="form-group date-main">
                          {/* <label className="form-select" htmlFor="date">Choose a Date</label> */}
                          <div className='date-field' style={{ width: "50%" }}>
                            <Controller
                              control={control}
                              name='order_date'
                              defaultValue={new Date(new Date().setDate(new Date().getDate() + 1))}
                              render={({ field }) => (
                                <DatePicker
                                  placeholderText='Select a Date'
                                  customInput={<ExampleCustomInput />}
                                  onChange={
                                    field.onChange
                                  }
                                  selected={field.value}
                                  minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                  maxDate={addDays(new Date(), 700)}
                                  className="form-control"
                                // dateFormat= "yyyy/MM/dd"
                                />
                              )}
                            />
                          </div>

                        </div>
                        {errors.order_date &&
                          <div className="invalid-feedback">{errors.order_date?.message}</div>
                        }
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <div className="form-hd-lbl date-hd">
                            <h3>Promo Code</h3>
                          </div>
                          <div className="form-group date-main">
                            <div className="form-group zipcode-grp">
                              <input name='promo_code' className="form-control form-zipcode" type="text" defaultValue='' {...register('promo_code')} />
                            </div>
                            { errors.promo_code &&
                              <div className="invalid-feedback">{errors.promo_code?.message}</div>
                            }
                          </div>
                        </div>
                      </div>
                      {/* <div className="col form-group-right-ic">
                        
                      </div> */}
                      {/* <div className='col'> */}
                      {/* <div className='date_img'>
                        <img src={dateIcon} alt='date Icon'></img>
                      </div> */}
                      {/* </div> */}
                      <input hidden className="form-control" {...register('plan_id')} defaultValue={planid} type="text" name="plan_id" id="plan_id" />
                      <input hidden className="form-control" {...register('replace_parts')} defaultValue={replaceparts} type="text" name="replace_parts" id="replace_parts" />
                    </div>
                  </div>
                  <div className="form-group timeslot-btn">
                    {isButtonLoading ?
                      <div className="btn btn-primary">Loading...</div>
                      :
                      <button className="btn btn-primary" type="submit">Pick Time Slot</button>
                    }
                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      ) 
      :
       (
        <div className='booking-info'>
          <Footer />
        </div>
      )}



      <Modal
        isOpen={bookingOrderTimeSlotModalIsOpen}
        onRequestClose={bookingOrderTimeSlotModalIsCloseModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        ariaHideApp={false}
        className="time-slot-popup"
        // style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="bookingOrderTimeSlot"
      >
        <div className='booking-wrp order-booking-time-popup'>
          <div className='rd-popup-wrp'>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                {/* {bookingOrderSuccess.order_id ?
                  <button className='reg-close' onClick={() => { navigate(`/order-details/${bookingOrderSuccess?.results?.order_id}`) }}>
                    <Icon path={mdiClose} size={'24px'} color="#222" />
                  </button>
                  : */}
                <button className='reg-close' onClick={bookingOrderTimeSlotModalIsCloseModal}>
                  <img src={closeIcon} alt='close Icon' />
                </button>
                {/* } */}
              </div>
            </div>
            {(bookingOrderSuccess?.results?._id) ?
              <div className="rd-popup-content">
                <h2>Confirmation ID:{bookingOrderSuccess?.results?._id}</h2>
                <p className='pb10'>Thank you for your order </p>
                {/* You will receive an email and text confirmation shortly. Your card will not be charged until the service is completed.</p> */}
                <div className="form-group">
                  <button className="btn btn-primary" onClick={() => { navigate(`/order-details/${bookingOrderSuccess?.results?._id}`) }}>View Orders</button>
                </div>
              </div>
              :
              <div className="rd-popup-content order-slot-cnt">
                <form onSubmit={modalhandleSubmit(onBookingSubmit)}>
                  <div className="form-group">
                    <div className='order-slot-pop'>
                      <div className='row'>
                        <div className='col'>
                          <div className="form-group text-left">
                            <label className="form-select" htmlFor="order_slot_time">Select Time Slot</label>
                            <Controller
                              name="order_slot_time"
                              control={modalControl}
                              render={({ field }) => (
                                <Select
                                  styles={customClockStyles}
                                  components={{ DropdownIndicator: timeDropdownIndicator }}
                                  isSearchable={false}
                                  className="react-dropdown popup_dropdown"
                                  placeholder='Select a Time'
                                  classNamePrefix="dropdown"
                                  options={bookingOrderTimeSlotData}
                                  isOptionDisabled={(bookingOrderTimeSlotData) => bookingOrderTimeSlotData.disabled}
                                  value={field.value} // Set the value of the Select component
                                  onChange={(selectedOption) => field.onChange(selectedOption)} // Update the field value on change
                                />
                              )}
                            />
                          </div>
                          {modalErrors.order_slot_time &&
                            <div className="invalid-feedback">{modalErrors.order_slot_time?.message || modalErrors.order_slot_time?.label.message}</div>
                          }
                          {bookingOrderError && (
                            <div className="invalid-feedback" style={{ display: "block", marginBottom: "10px" }}>
                              {bookingOrderError}
                            </div>
                          )}
                          <div className="form-group" style={{ marginTop: 80, marginBottom: 80 }}>
                            {orderTimeSlotButtonLoading ?
                              <div className="btn btn-primary">Loading...</div>
                              :
                              <button className="btn btn-primary" type="submit">Confirm</button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            }
          </div>
        </div>
      </Modal>


      <Modal
        isOpen={bookingModalIsOpen}
        onRequestClose={bookingModalIsCloseModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        ariaHideApp={false}
        // style={customStyles}
        className="time-slot-popup"
        overlayClassName="modal-Overlay"
        contentLabel="bookingOrderTimeSlot"
      >
        <div className='booking-wrp order-booking-time-popup'>
          <div className='rd-popup-wrp'>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <button className='reg-close' onClick={bookingModalIsCloseModal}>
                  <img src={closeIcon} alt='close Icon' />
                </button>

              </div>
            </div>
            {/* {console.log("order-success", orderSuccess)} */}
            {(orderSuccess?.results?._id) &&
              <div className="rd-popup-content">
                <h2 className="confirm-order-title" style={{ paddingTop: 20, color: "#000", fontSize: "1.6rem" }}>Confirmation</h2>
                <div className="confirm-order-dollar">
                  <img src={dollarIcon} alt='dollar Icon' />
                  <div className='order-cost'>
                    <div className='confirm-order-cost'>
                      <span>
                        {orderSuccess?.results?.plan?.currency}{Math.ceil(orderSuccess?.results?.customer_cost)}
                      </span>
                    </div>
                  </div>
                  <div className='order-confirm-name'>
                    <span>{orderSuccess?.results?.plan?.display_name}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        <div className='order-confirm-details'>
          <h4 className='order_id'>Order No:  {orderSuccess?.results?.ref_id}</h4>
          <div className='popup-description'>
            <div className='order-date-details'>
              <div className='calendar-img'>
                <img src={calendarIcon} alt='calendar Icon' />
              </div>
              <div className='date-format'>
                <span style={{ paddingLeft: 3 }}>{dateFormat(orderSuccess?.results?.slot_date_time)}</span>
              </div>
            </div>
            <div className='order-clock-details'>
              <div className='clock-img'>
                <img src={orderClockIcon} alt='order clock Icon' />
              </div>
              <div className='clock-details'>
                <span style={{ paddingLeft: 3 }}>{orderTime}</span>
              </div>
            </div>
            <div className='order-duration-details'>
              <div className='duration-img'>
                <img src={durationIcon} alt='duration Icon' />
              </div>
              <div className='duration-details'>
                <span style={{ paddingLeft: 3 }}>{orderSuccess?.results?.plan_duration} Mins</span>
              </div>
            </div>
            

          </div>
          <p className='pb50' style={{ paddingTop: 20, paddingBottom: 90, fontSize: "1.15rem", width: "22.3rem", margin: "0 auto" }}>Thank you for trusting your ride with us. A RideDoc <b>will be</b> assigned to your order soon.</p>
        </div>
      </Modal>

      <Modal
        isOpen={zipcodePopUp}
        onRequestClose={closeModelZipcode}
        ariaHideApp={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
      >
        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2> 
       <button >close</button> */}

        <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={closeModelZipcode}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              <p className='zipcode-popup-mssage'>Enter a Valid Zipcode.</p>
            </div>
          </div>
        </div>
        <div className='ok-button' style={{ width: "21%", margin: "0 auto" }}>
          <button className="btn btn-primary btn-ok" onClick={closeModelZipcode}> OK </button>
        </div>
      </Modal>
    </Fragment>
  );
}

function isoWithOffset() {
  const now = new Date();
  const offset = -now.getTimezoneOffset();
  const sign = offset >= 0 ? '+' : '-';
  const pad = (n) => String(Math.floor(Math.abs(n))).padStart(2, '0');

  const formatted =
    now.getFullYear() +
    '-' + pad(now.getMonth() + 1) +
    '-' + pad(now.getDate()) +
    'T' + pad(now.getHours()) +
    ':' + pad(now.getMinutes()) +
    ':' + pad(now.getSeconds()) +
    sign + pad(offset / 60) +
    ':' + pad(offset % 60);
  
  return formatted;
}


export default connect(mapStateToProps)(BookingTime);